import React, { useEffect, useState } from "react";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Container,
  Row,
  Col,
  Table,
  Badge,
  Button,
  Card,
  CardHeader,
  CardBody,
} from "reactstrap";
import { deletePublicationApi, getPublicationApi } from "src/network/api";
import LoaderComponent from "src/pages/components/LoaderComponent";
import PageLayout from "src/pages/PageLayout";
import { getApprovalStatusPill, getPRStatusPill } from "src/utils/appUtils";

const PublicationList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const response = await getPublicationApi();
      console.log(response);
      setData(response.data?.data);
    } catch (e) {
      console.log("Fetch Error:", e);
      toast.error(e.response?.data?.message ?? e.message);
    } finally {
      setLoading(false);
    }
  };

  const handleNavigateToEdit = (item) => {
    navigate(`/edit-publication/${item.ppuid}`, { state: { item } });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDelete = async (id) => {
    try {
      const response = await deletePublicationApi(id);
      if (response.status === 200 && response.data.status === 200) {
        toast.success(response.data?.message);
        fetchData();
      }
    } catch (e) {
      toast.error(e.response?.data?.message ?? e.message);
    }
  };

  if (loading) {
    return <LoaderComponent />;
  }

  return (
    <PageLayout>
      <div className="container-fluid mt-5">
        <Row>
          <Col lg="12">
            <Card className="shadow mb-4">
              <CardHeader className="bg-primary">
                <h3 className="mb-0 text-center font-weight-bold text-white">
                  Publication List
                </h3>
              </CardHeader>
              <CardBody>
                <Table bordered hover responsive className="table-sm mb-0">
                  <thead className="thead-light">
                    <tr>
                      <th>#</th>
                      <th>Title</th>
                      <th>Author</th>
                      <th>Journal Name</th>
                      <th>Date</th>
                      <th>Paper Type</th>
                      <th>ISSN</th>
                      <th>Volume</th>
                      <th>Issue</th>
                      <th>Publication Year</th>
                      <th>Indexing Partner</th>
                      <th>Description</th>
                      <th>Status</th>
                      <th>Delete</th>
                      <th>Edit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.length > 0 ? (
                      data.map((pub, index) => (
                        <tr key={pub.id}>
                          <th scope="row">{index + 1}</th>
                          <td>{pub.paper_title}</td>

                          <td>{pub.authors}</td>
                          <td>{pub.journal_name}</td>
                          <td>{pub.publication_date}</td>
                          <td>{pub.paper_type}</td>
                          <td>{pub.issn}</td>
                          <td>{pub.volume}</td>
                          <td>{pub.issue}</td>
                          <td>{pub.publication_year}</td>
                          <td>{pub.indexing_with}</td>
                          <td>{pub.description}</td>
                          <td>{getApprovalStatusPill(pub.approval_status)}</td>
                          <td>
                            <Button
                              color="danger"
                              size="sm"
                              onClick={() => {
                                handleDelete(pub.ppuid);
                              }}
                            >
                              <FaTrashAlt />
                            </Button>
                          </td>
                          <td>
                            <Button
                              color="info"
                              size="sm"
                              onClick={() => handleNavigateToEdit(pub)}
                            >
                              <FaEdit />
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={15} className="text-center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </PageLayout>
  );
};

export default PublicationList;
function empty(data: any[]) {
  throw new Error("Function not implemented.");
}
